import React, { useState } from "react";
import { useApp } from "../store";
import { X } from "lucide-react";

export default function AuthModal() {
  const { authOpen, setAuthOpen, login, signup } = useApp();
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (!authOpen) return null;

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      if (mode === "login") await login(email, password);
      else await signup(name, email, password);
      setAuthOpen(false); setName(""); setEmail(""); setPassword("");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Something went wrong");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/40 backdrop-blur-sm flex items-center justify-center px-4" data-testid="auth-modal">
      <div className="bg-[#FAF9F6] max-w-md w-full p-10 relative fade-up">
        <button onClick={() => setAuthOpen(false)} className="absolute top-4 right-4" aria-label="Close" data-testid="auth-close">
          <X size={20} strokeWidth={1.5} />
        </button>
        <div className="overline text-copper mb-3">{mode === "login" ? "Welcome back" : "Join the house"}</div>
        <h2 className="font-serif-display text-4xl mb-8 leading-tight">
          {mode === "login" ? "Sign in" : "Create an account"}
        </h2>
        <form onSubmit={submit} className="space-y-6">
          {mode === "signup" && (
            <div>
              <label className="overline text-xs block mb-2">Full name</label>
              <input className="input-underline" value={name} onChange={e => setName(e.target.value)} required data-testid="auth-name" />
            </div>
          )}
          <div>
            <label className="overline text-xs block mb-2">Email</label>
            <input type="email" className="input-underline" value={email} onChange={e => setEmail(e.target.value)} required data-testid="auth-email" />
          </div>
          <div>
            <label className="overline text-xs block mb-2">Password</label>
            <input type="password" className="input-underline" value={password} onChange={e => setPassword(e.target.value)} required data-testid="auth-password" />
          </div>
          {err && <div className="text-xs text-[#9E3C3C]" data-testid="auth-error">{err}</div>}
          <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="auth-submit">
            {busy ? "Please wait..." : (mode === "login" ? "Sign in" : "Create account")}
          </button>
        </form>
        <div className="mt-6 text-center text-xs text-[#5C5E5C]">
          {mode === "login" ? (
            <>New here?{" "}<button className="text-copper underline" onClick={() => setMode("signup")} data-testid="auth-switch-signup">Create account</button></>
          ) : (
            <>Already a member?{" "}<button className="text-copper underline" onClick={() => setMode("login")} data-testid="auth-switch-login">Sign in</button></>
          )}
        </div>
      </div>
    </div>
  );
}
